import {FOODIT_LOCALSTORAGE, PAYMENT_TYPES, PROMOTION_TYPES, SERVICE_TYPE} from '../constants/constant';
import {boolToServiceType} from './formHelper';
import {getValueFromLocalStorage, persistValueToLocalStorage} from './localStorage.helper';

export const getVoucherMessages = (promotions, serviceType) =>
  promotions.map(promotion => {
    if (
      promotion.type === 'VOUCHER' &&
      !promotion.applied &&
      promotion.message &&
      promotion.message.code !== 'invalid_fulfillment_method_type'
    ) {
      return {code: promotion.code, id: `checkout.voucherError.${promotion.message.code}`, values: null};
    } else if (
      promotion.type === 'VOUCHER' &&
      !promotion.applied &&
      promotion.message &&
      promotion.message.code === 'invalid_fulfillment_method_type'
    ) {
      return {
        code: promotion.code,
        id: 'checkout.voucherError.invalid_fulfillment_method_type',
        value: serviceType === SERVICE_TYPE.DELIVERY ? SERVICE_TYPE.COLLECTION : SERVICE_TYPE.DELIVERY
      };
    } else if (
      promotion.type === 'VOUCHER' &&
      promotion.applied
    ) {
      return {code: promotion.code, id: 'checkout.voucherAccepted', value: promotion.code};
    }
  });

export const getPlaceOrderButtonText = (paymentTypeValue, serviceTypeValue) => {
  if (paymentTypeValue === PAYMENT_TYPES.CREDIT_CARD) {
    return 'checkout.paymentByCreditCardButton';
  } else if (paymentTypeValue === PAYMENT_TYPES.PAYPAL) {
    return 'checkout.paymentByPayPalButton';
  } else if (paymentTypeValue === PAYMENT_TYPES.CASH && serviceTypeValue === SERVICE_TYPE.DELIVERY) {
    return 'checkout.paymentOnDeliveryButton';
  } else if (paymentTypeValue === PAYMENT_TYPES.CASH && serviceTypeValue === SERVICE_TYPE.COLLECTION) {
    return 'checkout.paymentOnCollectionButton';
  }

  return 'checkout.paymentCompleteOrderButton';
};

export const getServiceTypeInitialValue = (openForDelivery, openForCollection, fulfillment) => {
  if (openForDelivery && openForCollection) {
    return fulfillment && fulfillment.delivery ? boolToServiceType(fulfillment.delivery) : SERVICE_TYPE.COLLECTION;
  } else if (openForDelivery && !openForCollection) {
    return SERVICE_TYPE.DELIVERY;
  } else if (!openForDelivery && openForCollection) {
    return SERVICE_TYPE.COLLECTION;
  }

  return null;
};

export const storeBasketData = basketData => {
  const checkoutData = {};
  checkoutData.serviceType = basketData.serviceTypeValue || basketData.formValues.serviceType;
  checkoutData.addressLine1 = basketData.formValues.addressLine1;
  checkoutData.addressLine2 = basketData.formValues.addressLine2;
  checkoutData.postcode = basketData.formValues.postcode;
  checkoutData.city = basketData.formValues.city;
  checkoutData.name = basketData.formValues.name;
  checkoutData.email = basketData.formValues.email;
  checkoutData.phone = basketData.formValues.phone;
  checkoutData.paymentType = basketData.paymentTypeValue || basketData.formValues.paymentType;

  persistValueToLocalStorage(
    FOODIT_LOCALSTORAGE.CHECKOUT_DATA,
    checkoutData
  );
};

export const deletePostcodeFromLocalStorage = () => {
  const storedCheckoutData = getValueFromLocalStorage(FOODIT_LOCALSTORAGE.CHECKOUT_DATA);
  if (storedCheckoutData) {
    const checkoutDataModified = Object.assign({}, storedCheckoutData, { postcode: null });

    persistValueToLocalStorage(
      FOODIT_LOCALSTORAGE.CHECKOUT_DATA,
      checkoutDataModified
    );
  }
};

export const getVoucherInPromotion = vouchers => {
  let currentVoucher;
  vouchers.some(voucher => {
    if (voucher.type === PROMOTION_TYPES.VOUCHER) {
      currentVoucher = voucher;
    }
  });
  return currentVoucher;
};

const getIndexOfVouchInsideArray = array => {
  let index;
  array.some((voucher, i) => {
    if (voucher.type === PROMOTION_TYPES.VOUCHER) {
      index = i;
    }
  });
  if (index > -1) {
    return array[index];
  }
  return null;
};

export const compareVoucherDiff = (newArray, old) => {
  const newVoucher = getIndexOfVouchInsideArray(newArray);
  const oldVoucher = getIndexOfVouchInsideArray(old);
  if (newVoucher && oldVoucher) {
    return newVoucher.message !== oldVoucher.message;
  }
  return null;
};

export const checkMessgeContainsError = messages => {
  if (messages.length === 0) {
    return false;
  }
  return messages.some(message => message.level === 'ERROR');
};



// WEBPACK FOOTER //
// ./helpers/checkoutPage.helper.js